export default __webpack_public_path__ + "assets/images/c79eb03453ef87b225d91423e97bdefd.svg";